module.exports = __webpack_public_path__ + "static/media/examNotLogged.9e44ac86.jpg";